// TODO anhe92: Move this single function to websdk-utilities?! And remove this package.

// eslint-disable
export const getLocation = () =>
  // mock for testing
  // console.warn('returning location');
  ({
    href: 'https://www.test.org:433/path',
    hostname: 'www.test.org',
    foo: 'bar',
  });
